export const Token = {
    PAYMENTTOKEN: {
        name: 'USDT',
        figure: 6, //保留6位小数
    },
    AGD: {
        name: 'AGT',
        figure: 2, //保留6位小数
    },
    cToken: {
        name: 'cAG',
        figure: 6, //保留6位小数
    },
};
